import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieConsentOverlayComponent } from './cookie-consent-overlay.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilderModule } from '../form-builder/form-builder.module';
import { CookieConsentOverlayService } from './cookie-consent-overlay.service';
import { GenericModalService } from '../generic-modal/services/generic-modal.service';
import { FormBuilderService } from '../form-builder/shared/services/form-builder.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [CookieConsentOverlayComponent],
    imports: [CommonModule, FormsModule, FormBuilderModule, ReactiveFormsModule, TranslateModule.forChild()],
    exports: [CookieConsentOverlayComponent],
    providers: [CookieConsentOverlayService, GenericModalService, FormBuilderService]
})
export class CookieConsentOverlayModule {}
